import { Dispatch } from "redux";
import { showErrorMessage } from "./errorActions";

export const handleActionError = (error: any, dispatch: Dispatch, dispatchError: boolean = true) => {
  if (dispatchError) {
    dispatchActionError(error, dispatch);
  } else {
    throw error;
  }
};

export const dispatchActionError = (error: any, dispatch: Dispatch): void => {
  if (error && error.response && error.response.data && error.response.data.message) {
    dispatch(
      showErrorMessage({
        visible: true,
        message: error.response.data.message,
        ...error.response.data
      })
    );
  } else if (error && error.message) {
    dispatch(
      showErrorMessage({
        visible: true,
        ...error
      })
    );
  } else {
    dispatch(
      showErrorMessage({
        visible: true
      })
    );
  }
};
